<ng-container *ngFor="let item of items;let i=index;">
    <div class="scan-head mt-2 float-right product-popup">
        <span class="scan-head-item">
            <span class="product-popup-label">Qty</span>
            <span class="product-popup-content">
                {{item?.qty}}
            </span>
        </span>
        <span class="scan-head-item">
            <span class="product-popup-label">Price</span>
            <span class="product-popup-content">
                {{item?.price | currency}}
            </span>
        </span>
    </div>
    <app-fbm-order-poduct-info [item]="item">
    </app-fbm-order-poduct-info>
    <hr class="product-popup-divider" *ngIf="i <(items.length-1) ">
</ng-container>